(function(){
  'use strict';
  if (window.__gqaInit) return; window.__gqaInit = true;
  var root = document.getElementById('gqa-root'); if (!root) return;
  var CUR = root.getAttribute('data-currency') || '₹';
  var ANIM = parseInt(root.getAttribute('data-anim') || '320', 10);
  document.documentElement.style.setProperty('--gqa-anim', (ANIM/1000)+'s');

  var ALIAS = {'Double Armoured':'Tough Case','MagSafe Armoured':'Tough (MagSafe)','Slim Snap Case':'Snap Case','Glass Case':'Gloss Case'};
  var MAG = 'MagSafe Armoured', DOUBLE = 'Double Armoured';

  /* ===== model data (mirrored from grlhood-model-selector) ===== */
  var sBrands=["Apple","Samsung"];var aList=["Apple iPhone 17","Apple iPhone Air","Apple iPhone 17 Pro","Apple iPhone 17 Pro Max","Apple iPhone 16","Apple iPhone 16e","Apple iPhone 16 Plus","Apple iPhone 16 Pro","Apple iPhone 16 Pro Max","Apple iPhone 15","Apple iPhone 15 Plus","Apple iPhone 15 Pro","Apple iPhone 15 Pro Max","Apple iPhone 14","Apple iPhone 14 Plus","Apple iPhone 14 Pro","Apple iPhone 14 Pro Max","Apple iPhone 13","Apple iPhone 13 Mini","Apple iPhone 13 Pro","Apple iPhone 13 Pro Max","Apple iPhone 12","Apple iPhone 12 Mini","Apple iPhone 12 Pro","Apple iPhone 12 Pro Max","Apple iPhone 11","Apple iPhone 11 Pro","Apple iPhone 11 Pro Max"];var sD=["Samsung Galaxy S23","Samsung Galaxy S23 Plus","Samsung Galaxy S23 Ultra","Samsung Galaxy S24","Samsung Galaxy S24 Plus","Samsung Galaxy S24 Ultra","Samsung Galaxy S25","Samsung Galaxy S25 Plus","Samsung Galaxy S25 Ultra"];var sS=["Samsung Galaxy S23 Ultra","Samsung Galaxy S25 Plus","Samsung Galaxy S23 Plus","Samsung Galaxy S24","Samsung Galaxy S23","Samsung Galaxy S25","Samsung Galaxy S24 Plus","Samsung Galaxy S25 Ultra","Samsung Galaxy S24 Ultra"];
var siliconeData={"Apple":["iPhone 17 Pro Max","iPhone 17 Pro","iPhone 17 Air","iPhone 17","iPhone 16 Pro Max","iPhone 16 Pro","iPhone 16 Plus","iPhone 16","iPhone 16e","iPhone 15 Pro Max","iPhone 15 Pro","iPhone 15 Plus","iPhone 15","iPhone 14 Pro Max","iPhone 14 Pro","iPhone 14 Plus","iPhone 14","iPhone 13 Pro Max","iPhone 13 Pro","iPhone 13 Mini","iPhone 13","iPhone 12 Pro Max","iPhone 12 Pro","iPhone 12 Mini","iPhone 12","iPhone 11 Pro Max","iPhone 11 Pro","iPhone 11","iPhone SE (2022)","iPhone SE (2020)","iPhone XS Max","iPhone XS","iPhone XR","iPhone X","iPhone 8 Plus","iPhone 8","iPhone 7 Plus","iPhone 7","iPhone 6s Plus","iPhone 6s","iPhone 6 Plus","iPhone 6"],"Samsung":["Galaxy S25 Ultra","Galaxy S25 Plus","Galaxy S25 Edge","Galaxy S25 FE","Galaxy S25","Galaxy S24 Ultra","Galaxy S24 Plus","Galaxy S24 FE","Galaxy S24","Galaxy S23 FE","Galaxy S23 Ultra","Galaxy S23 Plus","Galaxy S23","Galaxy S22 Ultra 5G","Galaxy S22 Plus 5G","Galaxy S22 5G","Galaxy S21 FE","Galaxy S21 Ultra","Galaxy S21 Plus","Galaxy S21","Galaxy S20 Ultra","Galaxy S20 Plus","Galaxy S20 FE 5G","Galaxy S20 FE","Galaxy S20","Galaxy S10e","Galaxy S10 Plus","Galaxy S10 Lite","Galaxy S10","Galaxy S9 Plus","Galaxy S9","Galaxy S8 Plus","Galaxy S8","Galaxy Note 20 Ultra","Galaxy Note 20 5G","Galaxy Note 20","Galaxy Note 10 Plus","Galaxy Note 10 Lite","Galaxy Note 10","Galaxy Note 9","Galaxy M62","Galaxy M56","Galaxy M55","Galaxy M54 5G","Galaxy M53 5G","Galaxy M52 5G","Galaxy M51","Galaxy M40","Galaxy M35","Galaxy M34 5G","Galaxy M33 5G","Galaxy M32 5G","Galaxy M32","Galaxy M31s","Galaxy M31 Prime","Galaxy M31","Galaxy M30s","Galaxy M30","Galaxy M23 5G","Galaxy M21 2021","Galaxy M21","Galaxy M20","Galaxy M16","Galaxy M15","Galaxy M14","Galaxy M12","Galaxy M11","Galaxy M10s","Galaxy M10","Galaxy M06","Galaxy M02s","Galaxy F62","Galaxy F56 5G","Galaxy F55","Galaxy F54 5G","Galaxy F42 5G","Galaxy F41","Galaxy F34 5G","Galaxy F23 5G","Galaxy F22","Galaxy F16","Galaxy F15","Galaxy F14 5G","Galaxy F12","Galaxy F06 5G","Galaxy F02s","Galaxy A91","Galaxy A81","Galaxy A73 5G","Galaxy A72","Galaxy A71","Galaxy A70s","Galaxy A70","Galaxy A60","Galaxy A55","Galaxy A54 5G","Galaxy A53 5G","Galaxy A52s 5G","Galaxy A52 5G","Galaxy A52","Galaxy A51","Galaxy A50s","Galaxy A50","Galaxy A40s","Galaxy A40","Galaxy A36","Galaxy A35","Galaxy A34 5G","Galaxy A33 5G","Galaxy A32 5G","Galaxy A32 4G","Galaxy A31","Galaxy A30s","Galaxy A30","Galaxy A26","Galaxy A25 5G","Galaxy A23 5G","Galaxy A22 5G","Galaxy A22 4G","Galaxy A20","Galaxy A17","Galaxy A16","Galaxy A15 5G","Galaxy A14 5G","Galaxy A14 4G","Galaxy A12","Galaxy A11","Galaxy A10s","Galaxy A10","Galaxy A06","Galaxy A05s","Galaxy A04","Galaxy A03s","Galaxy A02s"],"OnePlus":["OnePlus 13T","OnePlus 13S","OnePlus 13","OnePlus 13R","OnePlus Nord 5","OnePlus Nord CE 5","OnePlus Nord 4","OnePlus Nord CE 4","OnePlus Nord CE 4 Lite 5G","OnePlus 12","OnePlus 12R","OnePlus Nord 3 5G","OnePlus Nord CE 3 5G","OnePlus Nord CE 3 Lite","OnePlus 11 5G","OnePlus 11R 5G","OnePlus Ace 2V","OnePlus Ace 2 5G","OnePlus 10T 5G","OnePlus 10R","OnePlus 10 Pro 5G","OnePlus 9RT","OnePlus 9R","OnePlus 9 Pro","OnePlus 9","OnePlus 8T","OnePlus 8 Pro","OnePlus 8","OnePlus 7T Pro","OnePlus 7T","OnePlus 7 Pro","OnePlus 7","OnePlus Nord 2T 5G","OnePlus Nord 2","OnePlus Nord","OnePlus Nord CE 2 Lite 5G","OnePlus Nord CE 2 5G","OnePlus Nord N20 5G","OnePlus Nord CE 5G","OnePlus Ace 2V","OnePlus Ace 2 5G","OnePlus Ace Racing","OnePlus Ace Pro 5G","OnePlus Ace 5G","OnePlus 6T","OnePlus 6","OnePlus 5T"],"Nothing":["Phone 3A Pro","Phone 3A","Phone 3","Phone 2A Plus","Phone 2A","Phone 2","Phone 1","CMF Phone 1","CMF Phone 2 Pro"],"Vivo":["X200 FE","X200 Pro","X200","X100 Pro","X100","X90 Pro","X90","X80 Pro 5G","X80 Lite","X80 5G","X70 Pro","X70","X60T","X60 Pro","X60","V50","V40e","V40 Pro","V40","V30e","V30 Pro","V30","V29e","V29 Pro","V29","V27e","V27 Pro","V27","V25e","V25 Pro 5G","V25 5G","V23e 5G","V23 Pro 5G","V23 5G","V21s","V21e","V21 5G","V21","V20 SE","V20 Pro","V20","V19","V17 Pro","V17","V15 Pro","T4X","T4","T3X","T3 Ultra","T3 Pro","T3 5G","T2X 5G (International)","T2 Pro 5G","T2 5G","T1 Pro 5G","T1 5G","S18 Pro","S18","S16e","S16 Pro","S16","S15e","S15 Pro","S12 Pro","S12","S10e","S1 Pro (International)","S1 Pro","S1","S7","Y300 Pro","Y300 Plus","Y300","Y200t","Y200e","Y200 Pro","Y200","Y100a","Y100 (International)","Y100","Y75s","Y75 5G","Y73t","Y73","Y72 5G (International)","Y70","Y56 5G","Y55 5G","Y52t","Y52 5G","Y38","Y36","Y35+ 5G","Y35","Y33s 5G","Y33e","Y30 5G","Y29 4G","Y28s","Y27","Y22s","Y22","Y18e","Y16","Y03","Z5X","Z1X","Z1 Pro"],"Redmi":["Note 14 Pro Plus","Note 14 Pro","Note 14","Note 13 Pro Plus","Note 13 Pro","Note 13","Note 12 Pro Plus","Note 12 Pro","Note 12 5G","Note 12 4G","Note 11T Pro Plus","Note 11T Pro","Note 11T 5G","Note 11SE 5G (International)","Note 11S 5G","Note 11S","Note 11E Pro","Note 11 SE","Note 11 Pro+ 5G","Note 11 Pro Plus 5G (International)","Note 11 Pro 5G (International)","Note 11 Pro","Note 11 (International)","Note 11","Note 10T 5G","Note 10S","Note 10 Pro Max","Note 10 Pro","Note 10 Lite","Note 10 5G","Note 10","Note 9S","Note 9 Pro Max","Note 9 Pro 5G","Note 9 Pro","Note 9","Note 8 Pro","Note 8 (2021)","Note 8","Note 7S","Note 7 Pro","Note 7","K50i","K40 Gaming","K40","K30i 5G","K30","K20 Pro","K20","13C 5G","13 5G","12 5G","12 4G","10X 4G","9T","9 Power","7A"],"Poco":["X6 Pro","X6","X5 Pro 5G","X5 5G","X5","X4 Pro 5G","X4 GT","X3 Pro","X3 NFC","X3","X2","M6 Pro 5G","M5s","M4 Pro 5G","M3 Pro 5G","M2 Pro","F6","F5 5G","F4 5G","F3 GT","F3","F1"],"Xiaomi":["15 Ultra","15","14 Ultra","14","13 Pro","12X","12S Pro","12 Pro 5G","12 Lite 5G","11T Pro 5G","11T 5G","11i HyperCharge 5G","11i 5G","11 Lite NE 5G","11 Lite","Note 10 (International)","11X Pro","11X","11 Ultra","10T Pro","10T Lite 5G","10T","10i","9T Pro","9T","A3"],"Motorola":["Moto G86 Power 5G","Moto G85 5G","Moto G84","Moto G64","Moto G54","Moto G45","Edge 60 Ultra","Edge 60 Pro","Edge 60 Fusion","Edge 60","Edge 50 Ultra","Edge 50 Pro","Edge 50 Fusion","Edge 50","Edge 40 Neo","Edge 40","Edge 30 Ultra","Edge 30 Fusion","Edge 30"],"iQOO":["Z10X","Z10","Z9X","Z9S Pro","Z9S","Z9 Lite","Z9","Z7S","Z7 Pro 5G","Z7 (International)","Z7","Z6X","Z6 Pro 5G","Z6 Lite","Z6 (International)","Z6","Z5","Z3","Neo9 Pro","Neo9","Neo7 SE","Neo7 Racing","Neo6 SE","Neo 7 Pro","Neo 7","Neo 6 5G","Neo 5S","Neo 5","Neo 10R","9T 5G","9 SE 5G","9 Pro 5G","9 5G (International)","9 5G","8 5G","7 Legend 5G","7","3","13","12","11","10"],"Oppo":["Reno13 Pro","Reno13","Reno12 Pro 5G","Reno12 5G","Reno11 Pro","Reno11","Reno10 Pro Plus 5G","Reno10 Pro 5G","Reno10 5G","Reno10X Zoom","Reno8 Z","Reno8 Lite","Reno8 4G","Reno8T 5G","Reno8 Pro 5G","Reno8 5G","Reno7 Z 5G","Reno7 Lite","Reno7","Reno7 Pro 5G","Reno7 5G","Reno6 Pro Plus 5G","Reno6 Pro 5G (International)","Reno6 Pro 5G","Reno6 5G","Reno5 Lite","Reno5 F","Reno5 Pro","Reno4F","Reno4 Pro","Reno4 Lite","Reno3 Pro (International)","Reno3","Reno2Z","Reno2F","Reno2","Reno Ace","Find X8 Pro","Find X8","Find N3 (Front)","Find N3 (Back)","K13","K12","K5","K3","F29 Pro","F29","F27 Pro Plus","F27 Pro","F25 Pro","F23 5G","F21s Pro 5G","F21s Pro 4G","F21 Pro 5G","F21 Pro 4G","F19 Pro Plus","F19 Pro","F19","F17 Pro","F17","F15","F11 Pro","A96 (International)","A94","A93","A91","A9 (2020)","A79","A78 5G","A74","A73 (2020)","A59","A58X","A58 (International)","A5 Pro","A5 (2020)","A3 Pro","A11X","A11","A1 Pro"],"Realme":["14X","14 Pro Plus","14 Pro","13 Pro Plus","13 Pro","13","12X","12 Pro Plus","12 Pro","12 Plus","12","11X 5G","11 Pro+","11 Pro","11 (International)","11 5G","10 Pro Plus 5G","10 Pro 5G","GT Neo 6","GT Neo 6 SE","GT Neo 3T","GT Neo 3","GT Neo 2T","GT Neo 2","GT Neo Flash","GT 7 Pro","GT 7","GT 6T","GT 6","GT 5G","GT 2 Pro","GT 2","Narzo 70X","Narzo 70 Turbo","Narzo 70 Pro","Narzo 70","Narzo 60X 5G","Narzo 60 Pro","Narzo 60","Narzo 50 Pro","Narzo 30 5G","Narzo 20 Pro","Narzo 10","C75","C65 5G","9i 4G","9 Pro Plus 5G","9 Pro 5G","9 5G Speed Edition","9 5G","9 4G","8s 5G","8 Pro","8 5G","8","7 Pro","7","6s","6i","6 Pro","6","5s","5 Pro","5","3 Pro","X7 Pro","X7 Max 5G","X7 (International)","X50 Pro","X2 Pro","X2","X Lite","X","V60 Pro","V25","V13 5G","Q5 Pro","Q5","Q3i 5G","Q3 Pro 5G","Q3 5G","Q2 Pro (International)"]};
var glassData=JSON.parse(JSON.stringify(siliconeData));
  /* merchant-added models (mirrors the PDP selector's add_* block settings) */
  var qaAdded={};
  function qaPA(vn,str){ if(!str)return; str.split(',').forEach(function(e){ e=e.trim(); if(!e)return; var p=e.split('|'); if(p.length!==2)return; var b=p[0].trim(), m=p[1].trim(); if(!qaAdded[vn])qaAdded[vn]={}; if(!qaAdded[vn][b])qaAdded[vn][b]=[]; qaAdded[vn][b].push(m); }); }
  qaPA(DOUBLE, root.getAttribute('data-add-armoured'));
  qaPA(MAG, root.getAttribute('data-add-armoured'));
  qaPA('Slim Snap Case', root.getAttribute('data-add-slim'));
  qaPA('Glass Case', root.getAttribute('data-add-glass'));
  qaPA('Silicone Clear Case', root.getAttribute('data-add-silicone'));
  var qaRemoved=(root.getAttribute('data-remove-models')||'').split(',').map(function(x){return x.trim();}).filter(Boolean);
  var qaNew={}; (root.getAttribute('data-new-models')||'').split(',').forEach(function(x){ x=x.trim(); if(x) qaNew[x]=1; });
  function gqaModels(t,b){var l=[];if(t==="Silicone Clear Case")l=(siliconeData[b]||[]).slice();else if(t===DOUBLE||t===MAG){if(b==="Samsung")l=sD.slice();else if(b==="Apple")l=aList.slice()}else if(t==="Slim Snap Case"){if(b==="Samsung")l=sS.slice();else if(b==="Apple")l=aList.slice()}else l=(glassData[b]||[]).slice();
    if(qaAdded[t]&&qaAdded[t][b])qaAdded[t][b].forEach(function(m){if(l.indexOf(m)===-1)l.unshift(m)});
    if(qaRemoved.length)l=l.filter(function(m){return qaRemoved.indexOf(m)===-1});
    return l}
  function disp(t,b,m){ if(t!=="Silicone Clear Case" && m.indexOf(b+' ')===0) return m.slice(b.length+1); return m; }
  function gqaBrands(t){ if(t==="Silicone Clear Case") return Object.keys(siliconeData); if(t===DOUBLE||t===MAG||t==="Slim Snap Case") return sBrands.slice(); return Object.keys(glassData); }

  function money(cents){ var n=Math.round(cents/100); return CUR + n.toLocaleString('en-IN'); }

  /* ===== decorate every product card with the + row ===== */
  function decorate(){
    document.querySelectorAll('product-card:not([data-gqa])').forEach(function(pc){
      pc.setAttribute('data-gqa','1');
      var link = pc.querySelector('a[href*="/products/"]'); if(!link) return;
      var m = (link.getAttribute('href')||'').match(/\/products\/([^/?#]+)/); if(!m) return;
      var handle = m[1];
      var content = pc.querySelector('.product-card__content') || pc;
      // gather title + price nodes (everything after the gallery)
      var gallery = content.querySelector('.card-gallery');
      var meta = document.createElement('div'); meta.className='gqa-meta';
      Array.prototype.slice.call(content.children).forEach(function(ch){
        if (ch===gallery || ch.contains(gallery) || (gallery && gallery.contains(ch))) return;
        if (ch.classList && ch.classList.contains('gqa-row')) return;
        meta.appendChild(ch);
      });
      var row = document.createElement('div'); row.className='gqa-row';
      var btn = document.createElement('button');
      btn.type='button'; btn.className='gqa-plus'; btn.setAttribute('aria-label','Quick add');
      btn.setAttribute('data-gqa-handle', handle);
      btn.innerHTML='<svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
      row.appendChild(btn); row.appendChild(meta);
      content.appendChild(row);
    });
  }
  var PLUS_ON = root.getAttribute('data-plus') !== 'false';
  if (PLUS_ON) {
    decorate();
    var gqaMoT = null;
    new MutationObserver(function(){
      if (gqaMoT) return;
      gqaMoT = setTimeout(function(){ gqaMoT = null; decorate(); }, 180);
    }).observe(document.body,{childList:true,subtree:true});
  }

  /* ===== overlay shell ===== */
  var overlay = document.createElement('div');
  overlay.id='gqa-overlay';
  overlay.innerHTML='<div class="gqa-scrim" data-gqa-close></div><div class="gqa-card" role="dialog" aria-modal="true"><div class="gqa-inner" style="display:flex;flex-direction:column;min-height:0;height:100%"></div><div class="gqa-ddscrim" data-gqa-ddscrim></div></div>';
  document.body.appendChild(overlay);
  if ((root.getAttribute('data-pos')||'') === 'left') overlay.classList.add('gqa-pos-left');
  var cardEl = overlay.querySelector('.gqa-card');
  var inner = overlay.querySelector('.gqa-inner');

  var closeT = null, lockY = 0, locked = false;
  function lockScroll(){
    if (locked) return;              /* rapid reopen while still locked: keep the original position */
    locked = true;
    lockY = window.scrollY || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll(){
    if (!locked) return;
    locked = false;
    var html = document.documentElement;
    var sb = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';   /* restore must be INSTANT, never smooth-scrolled */
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, lockY);
    html.style.scrollBehavior = sb;
    try { if (window.lenis && window.lenis.scrollTo) window.lenis.scrollTo(lockY, { immediate: true }); } catch (e) {}
  }
  function openOverlay(){ if (closeT){ clearTimeout(closeT); closeT=null; } overlay.classList.add('gqa-on'); requestAnimationFrame(function(){ requestAnimationFrame(function(){ overlay.classList.add('gqa-in'); }); }); lockScroll(); }
  function closeOverlay(){ overlay.classList.remove('gqa-in'); if (window.__gqaGalT) clearInterval(window.__gqaGalT); closeT = setTimeout(function(){ closeT=null; overlay.classList.remove('gqa-on'); unlockScroll(); inner.innerHTML=''; cardEl.style.height=''; var sp=cardEl.querySelector(':scope > .gqa-dd-panel'); if(sp) sp.remove(); cardEl.classList.remove('gqa-ddopen'); }, ANIM+40); }
  overlay.addEventListener('click', function(e){
    if (e.target.closest('[data-gqa-ddscrim]')){
      var dd0=overlay.querySelector('.gqa-dd'); if(dd0) dd0.classList.remove('gqa-open');
      cardEl.classList.remove('gqa-ddopen'); return;
    }
    if(e.target.closest('[data-gqa-close]')) closeOverlay();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && overlay.classList.contains('gqa-on')) closeOverlay(); });

  var cache = {};
  function fetchProduct(handle){
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p){ cache[handle]=p; return p; });
  }

  /* warm the cache the moment a finger/cursor nears the + */
  ['pointerenter','touchstart','focusin'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      var b = e.target.closest ? e.target.closest('.gqa-plus') : null;
      if (b) fetchProduct(b.getAttribute('data-gqa-handle'));
    }, true);
  });
  var SKEL = '<div class="gqa-load"><div class="gqa-spin" aria-label="Loading"></div></div>';
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.gqa-plus') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var handle = b.getAttribute('data-gqa-handle');
    inner.innerHTML = SKEL;           /* open NOW, fill when data lands */
    openOverlay();
    fetchProduct(handle).then(function(p){ build(p); }).catch(function(){ closeOverlay(); });
  }, true);

  /* ===== build the quick-add UI for a product ===== */
  function build(p){
    var st = { variant:null, brand:'', model:'' };
    var variants = p.variants || [];
    var byTitle = {}; variants.forEach(function(v){ byTitle[v.title]=v; });
    var magVar = byTitle[MAG] || null;
    var pillVars = variants.filter(function(v){ return v.title!=='Default Title'; });
    var isCaseProduct = variants.some(function(v){ return ALIAS[v.title] || v.title==='Silicone Clear Case'; });
    if (!pillVars.length) pillVars = variants.slice(0,1);
    st.variant = byTitle[DOUBLE] || pillVars[0];

    /* image ranges — same marker logic as the PDP */
    var imgs = (p.images||[]).slice();
    var markers = [];
    variants.forEach(function(v){
      if (v.featured_image && typeof v.featured_image.position==='number'){
        markers.push({t:v.title, pos:v.featured_image.position-1});
      }
    });
    markers.sort(function(a,b){ return a.pos-b.pos; });
    var ranges = {};
    markers.forEach(function(mk,i){
      var end = i<markers.length-1 ? markers[i+1].pos-1 : imgs.length-1;
      ranges[mk.t] = [mk.pos, end];
    });
    function slidesFor(title){
      var r = ranges[title] || (title===MAG ? ranges[DOUBLE] : null);
      if (!r || r[0]<0 || r[0]>=imgs.length) return imgs;
      return imgs.slice(r[0], r[1]+1);
    }

    /* the white-background flat lay leads the quick-add gallery — detected
       client-side by sampling the 4 corners of each image's 160px thumb */
    var WBG = {};
    function probeSlides(list, cb){
      var pend = 0;
      list.forEach(function(u){
        if (WBG[u] !== undefined) return;
        pend++;
        var url = (u.indexOf('//')===0 ? 'https:'+u : u);
        var p = new Image(); p.crossOrigin = 'anonymous';
        var fin = function(v){ WBG[u] = v; if (--pend === 0) cb(); };
        p.onload = function(){ try{
          var c = document.createElement('canvas'); c.width = c.height = 8;
          var x = c.getContext('2d'); x.drawImage(p, 0, 0, 8, 8);
          var d = x.getImageData(0, 0, 8, 8).data, ix = [0, 7, 56, 63];
          fin(ix.every(function(i){ return d[i*4]>240 && d[i*4+1]>240 && d[i*4+2]>240; }));
        }catch(e){ fin(false); } };
        p.onerror = function(){ fin(false); };
        p.src = url + (url.indexOf('?')>-1?'&':'?') + 'width=160';
      });
      return pend > 0;
    }
    function orderSlides(slides){
      for (var i = 0; i < slides.length; i++){
        if (WBG[slides[i]]){
          if (i > 0){ var s = slides.slice(); s.unshift(s.splice(i,1)[0]); return s; }
          break;
        }
      }
      return slides;
    }

    function effTitle(){ return st.variant ? st.variant.title : ''; }
    function effVariant(){ return st.variant; }

    var showOffer = root.getAttribute('data-show-offer')==='true';
    var html = ''
      + '<button type="button" class="gqa-x" data-gqa-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>'
      + '<div class="gqa-gal-wrap">'
      +   (showOffer ? '<div class="gqa-offer">'+root.getAttribute('data-offer')+'</div>' : '')
      +   '<div class="gqa-gal" data-gqa-gal></div>'
      +   '<div class="gqa-dots" data-gqa-dots></div>'
      + '</div>'
      + '<div class="gqa-body">'
      +   '<div class="gqa-head"><h3 class="gqa-title">'+p.title+'</h3>'
      +   '<div class="gqa-prices"><span class="gqa-price" data-gqa-price></span><span class="gqa-cprice" data-gqa-cprice hidden></span></div></div>'
      +   '<div class="gqa-pills" data-gqa-pills></div>'
      +   '<div class="gqa-dd" data-gqa-dd>'
      +     '<button type="button" class="gqa-dd-btn" data-gqa-ddbtn><span data-gqa-ddtext>'+root.getAttribute('data-model-placeholder')+'</span>'
      +       '<span class="gqa-dd-chev"><svg viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span></button>'
      +     '<div class="gqa-dd-panel">'
      +       '<div class="gqa-dd-search"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg><input type="text" placeholder="Search your model" data-gqa-search></div>'
      +       '<div class="gqa-dd-brands" data-gqa-brands></div>'
      +       '<div class="gqa-dd-list" data-gqa-list></div>'
      +     '</div>'
      +   '</div>'
      +   '<div class="gqa-model-err" data-gqa-err>'+root.getAttribute('data-model-error')+'</div>'
      +   '<button type="button" class="gqa-atb" data-gqa-atb>'
      +     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 12.2a1 1 0 01-1 .8H7.2a1 1 0 01-1-.8L5 8z"/><path d="M9 10V6.5a3 3 0 016 0V10"/></svg>'
      +     root.getAttribute('data-atb-label')+'</button>'
      +   (p.handle ? '<a class="gqa-view" data-gqa-view href="/products/'+p.handle+'">'+(root.getAttribute('data-view-label')||'View Product Page')+'</a>' : '')
      + '</div>';
    inner.innerHTML = html;

    var gal = inner.querySelector('[data-gqa-gal]');
    var dots = inner.querySelector('[data-gqa-dots]');
    var priceEl = inner.querySelector('[data-gqa-price]');
    var cpriceEl = inner.querySelector('[data-gqa-cprice]');
    var pillsEl = inner.querySelector('[data-gqa-pills]');
    var dd = inner.querySelector('[data-gqa-dd]');
    var ddBtn = inner.querySelector('[data-gqa-ddbtn]');
    var ddText = inner.querySelector('[data-gqa-ddtext]');
    var brandsEl = inner.querySelector('[data-gqa-brands]');
    var listEl = inner.querySelector('[data-gqa-list]');
    var searchEl = inner.querySelector('[data-gqa-search]');
    var errEl = inner.querySelector('[data-gqa-err]');
    var atbEl = inner.querySelector('[data-gqa-atb]');
    var ddPanel = dd.querySelector('.gqa-dd-panel');
    var bodyEl = inner.querySelector('.gqa-body');

    /* the body scroll-clips absolute children, so the panel lives on the card itself
       and is positioned in card coordinates, opening upward above the button */
    var stale = cardEl.querySelector(':scope > .gqa-dd-panel');
    if (stale && stale !== ddPanel) stale.remove();
    cardEl.appendChild(ddPanel);
    function positionDD(){
      var cr = cardEl.getBoundingClientRect(), br = ddBtn.getBoundingClientRect();
      ddPanel.style.position='absolute';
      ddPanel.style.left=(br.left-cr.left)+'px';
      ddPanel.style.width=br.width+'px';
      ddPanel.style.bottom=(cr.bottom-br.top+8)+'px';
      ddPanel.style.top='auto';
      ddPanel.style.zIndex='9';
      ddPanel.style.maxHeight=Math.max(180, br.top-cr.top-20)+'px';
      ddPanel.style.overflowY='auto';
    }
    function openDD(){ dd.classList.add('gqa-open'); ddPanel.classList.add('gqa-panel-open'); cardEl.classList.add('gqa-ddopen'); positionDD(); }
    function closeDD(){ dd.classList.remove('gqa-open'); ddPanel.classList.remove('gqa-panel-open'); cardEl.classList.remove('gqa-ddopen'); }
    if (window.__gqaResize) window.removeEventListener('resize', window.__gqaResize);
    window.__gqaResize = function(){ if(dd.classList.contains('gqa-open')) positionDD(); };
    window.addEventListener('resize', window.__gqaResize);
    bodyEl.addEventListener('scroll', function(){ if(dd.classList.contains('gqa-open')) closeDD(); }, {passive:true});

    var GALMODE = root.getAttribute('data-gal-mode') || 'crossfade';
    var AUTOPLAY = root.getAttribute('data-autoplay') === 'true';
    var AUTOMS = (parseInt(root.getAttribute('data-autoplay-s')||'4',10))*1000;
    var galIdx = 0;
    function imgTag(u,i,eager){
      var url = u.indexOf('//')===0 ? 'https:'+u : u;
      return '<img src="'+url+(url.indexOf('?')>-1?'&':'?')+'width=900" '+(eager?'':'loading="lazy" ')+'alt="">';
    }
    function markDots(i){ Array.prototype.forEach.call(dots.children, function(d,j){ d.classList.toggle('gqa-dot-on', j===i); }); }
    function renderGallery(){
      var slides = orderSlides(slidesFor(effTitle()));
      /* async probe: once backgrounds are known, re-render (only if untouched) */
      probeSlides(slides, function(){ if (galIdx === 0) renderGallery(); });
      galIdx = 0;
      var PER = parseInt(root.getAttribute('data-imgs-win')||'2',10) || 2;
      if (GALMODE === 'crossfade'){
        gal.classList.add('gqa-fade');
        var wins = [];
        for (var w = 0; w < slides.length; w += PER) wins.push(slides.slice(w, w + PER));
        gal.innerHTML = wins.map(function(pair, wi){
          return '<div class="gqa-win'+(wi===0?' gqa-cur':'')+'">'
            + pair.map(function(u,i){ return imgTag(u,i,wi<2); }).join('') + '</div>';
        }).join('');
      } else {
        gal.classList.remove('gqa-fade');
        gal.innerHTML = slides.map(function(u,i){ return imgTag(u,i,i===0); }).join('');
        gal.scrollLeft = 0;
      }
      var dotCount = (GALMODE === 'crossfade') ? Math.ceil(slides.length / PER) : slides.length;
      dots.innerHTML = Array.apply(null, Array(dotCount)).map(function(_,i){ return '<span class="gqa-dot'+(i===0?' gqa-dot-on':'')+'"></span>'; }).join('');
    }
    function goTo(i){
      var im = gal.querySelectorAll('.gqa-win');
      if (!im.length) im = gal.querySelectorAll(':scope > img');
      if (!im.length) return;
      i = (i + im.length) % im.length;
      if (im[galIdx]) im[galIdx].classList.remove('gqa-cur');
      im[i].classList.add('gqa-cur'); galIdx = i; markDots(i);
    }
    /* click left/right half + swipe to change slide (crossfade) */
    var swX = null;
    gal.addEventListener('pointerdown', function(e){ swX = e.clientX; }, {passive:true});
    gal.addEventListener('pointerup', function(e){
      if (GALMODE !== 'crossfade' || swX === null) return;
      var dx = e.clientX - swX; swX = null;
      if (Math.abs(dx) > 30) { goTo(galIdx + (dx < 0 ? 1 : -1)); return; }
      var r = gal.getBoundingClientRect();
      goTo(galIdx + ((e.clientX - r.left) > r.width/2 ? 1 : -1));
    }, {passive:true});
    gal.addEventListener('scroll', function(){
      if (GALMODE === 'crossfade') return;
      markDots(Math.round(gal.scrollLeft / gal.clientWidth));
    }, {passive:true});
    if (window.__gqaGalT) clearInterval(window.__gqaGalT);
    if (AUTOPLAY && GALMODE === 'crossfade') window.__gqaGalT = setInterval(function(){ goTo(galIdx+1); }, AUTOMS);

    var viewEl = inner.querySelector('[data-gqa-view]');
    function renderPrice(){
      var v = effVariant(); if (!v) return;
      if (viewEl && p.handle) viewEl.setAttribute('href', '/products/' + p.handle + '?variant=' + v.id);
      priceEl.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price){ cpriceEl.textContent = money(v.compare_at_price); cpriceEl.style.visibility = ''; }
      else { cpriceEl.textContent = '\u00A0'; cpriceEl.style.visibility = 'hidden'; }
    }
    function renderPills(){
      pillsEl.innerHTML = pillVars.map(function(v){
        var name = ALIAS[v.title] || v.title;
        return '<button type="button" class="gqa-pill'+(st.variant&&st.variant.id===v.id?' gqa-sel':'')+'" data-vid="'+v.id+'">'+name+' <small>'+money(v.price)+'</small></button>';
      }).join('');
    }
    function resetModelIfInvalid(){
      if (!st.brand) return;
      var list = gqaModels(st.variant?st.variant.title:'', st.brand);
      if (st.model && list.indexOf(st.model)===-1){ st.model=''; ddText.textContent = root.getAttribute('data-model-placeholder'); ddBtn.classList.remove('gqa-has'); }
    }
    function renderBrands(){
      var bl = gqaBrands(st.variant ? st.variant.title : '');
      if (bl.indexOf(st.brand) === -1) st.brand = bl[0] || '';
      brandsEl.innerHTML = bl.map(function(b){
        return '<button type="button" class="gqa-brand'+(b===st.brand?' gqa-sel':'')+'" data-b="'+b+'">'+b+'</button>';
      }).join('');
    }
    function renderList(){
      var t = st.variant ? st.variant.title : '';
      var q = (searchEl.value||'').trim().toLowerCase();
      var models = gqaModels(t, st.brand).map(function(mm){ return {raw:mm, d:disp(t, st.brand, mm)}; });
      if (q) models = models.filter(function(mm){ return mm.d.toLowerCase().indexOf(q)>-1 || mm.raw.toLowerCase().indexOf(q)>-1; });
      listEl.innerHTML = models.length ? models.map(function(mm){
        var tag=(qaNew[mm.raw]||qaNew[mm.d])?'<span class="gqa-new">NEW</span>':'';
        return '<div class="gqa-dd-item'+(mm.raw===st.model?' gqa-sel':'')+'" data-m="'+mm.raw.replace(/"/g,'&quot;')+'"><span class="gqa-dd-item-l">'+mm.d+tag+'</span>'
          +(mm.raw===st.model?'<svg width="16" height="16" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/></svg>':'')+'</div>';
      }).join('') : '<div class="gqa-dd-none">No models found</div>';
    }

    st.brand = gqaBrands(st.variant ? st.variant.title : '')[0] || 'Apple';
    if (!isCaseProduct){ dd.style.display='none'; if(pillVars.length<2) pillsEl.style.display='none'; }
    renderGallery(); renderPrice(); renderPills(); renderBrands(); renderList();
    cardEl.style.height = '';
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      var h = cardEl.getBoundingClientRect().height;
      if (h > 200) cardEl.style.height = h + 'px';   /* freeze size: variant switches can never resize the card */
    }); });

    if (cardEl.__gqaClick) cardEl.removeEventListener('click', cardEl.__gqaClick);
    cardEl.__gqaClick = function(e){
      var el;
      if ((el = e.target.closest('.gqa-pill'))){
        var vid = +el.getAttribute('data-vid');
        st.variant = variants.filter(function(v){ return v.id===vid; })[0] || st.variant;
        renderBrands();
        resetModelIfInvalid();
        renderPills(); renderPrice(); renderGallery(); renderList();
        return;
      }
      if (e.target.closest('[data-gqa-ddbtn]')){ if(dd.classList.contains('gqa-open')) closeDD(); else { openDD(); if (window.matchMedia && matchMedia('(hover:hover)').matches) searchEl.focus(); } return; }
      if ((el = e.target.closest('.gqa-brand'))){ st.brand = el.getAttribute('data-b'); renderBrands(); renderList(); return; }
      if ((el = e.target.closest('.gqa-dd-item'))){
        st.model = el.getAttribute('data-m');
        ddText.textContent = st.brand + ' · ' + disp(st.variant?st.variant.title:'', st.brand, st.model);
        ddBtn.classList.add('gqa-has'); ddBtn.classList.remove('gqa-err'); errEl.classList.remove('gqa-show');
        closeDD(); renderList(); return;
      }
      if (e.target.closest('[data-gqa-atb]')){ addToBag(); return; }
      if (!e.target.closest('.gqa-dd') && !e.target.closest('.gqa-dd-panel')) closeDD();
    };
    cardEl.addEventListener('click', cardEl.__gqaClick);
    searchEl.addEventListener('input', renderList);

    function addToBag(){
      if (isCaseProduct && (!st.model || !st.brand)){ ddBtn.classList.add('gqa-err'); errEl.classList.add('gqa-show'); return; }
      var v = effVariant(); if (!v) return;
      atbEl.disabled = true;
      window.__gqaAdding = true;
      var fd = new FormData();
      fd.append('id', v.id); fd.append('quantity','1');
      if (isCaseProduct){
        fd.append('properties[Brand]', st.brand);
        fd.append('properties[Device Model]', st.model);
      }
      fetch('/cart/add.js', { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'}, body: fd })
        .then(function(r){ return r.json(); })
        .then(function(){
          closeOverlay();
          document.dispatchEvent(new CustomEvent('cart:update',{detail:{data:{source:'product-form-component'}}}));
          try { if (window.GC && typeof GC.open==='function') GC.open(); else document.dispatchEvent(new CustomEvent('cart:open')); } catch(err){}
        })
        .catch(function(){})
        .then(function(){ atbEl.disabled = false; window.__gqaAdding = false; });
    }
  }
})();